"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jsxToString = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
} // Returns a string of the children of a JSX object
//  children: the children props from the JSX object
//  tabs: the number of tabs to pad the string to keep everything consistent
//  block: whether it should be returned in block or inline format


var childGetter = function childGetter(children, tabs, block) {
  var retval = "";
  var strJSXMix = false;
  var numChildren = 0; // If there is a mix of JSX objects and strings set strJSXMix to true and counts number of children

  _react.default.Children.forEach(children, function (child) {
    if (!_react.default.isValidElement(child)) {
      strJSXMix = true;
    }

    numChildren += 1;
  }); // For each child, convert it to a string. If the children are a mix of JSX and strings then print inline format despite what block is set to


  _react.default.Children.forEach(children, function (child, index) {
    if (_react.default.isValidElement(child)) {
      retval += strJSXMix ? jsxToString(child, "".concat(tabs, "  "), false) : jsxToString(child, "".concat(tabs, "  "), block);
      retval += index !== numChildren - 1 && block ? "\n".concat(tabs, "  ") : '';
    } else {
      retval += child.toString();
    }
  });

  return retval;
}; // Returns a string of the props of a JSX object


var propGetter = function propGetter(obj) {
  var str = '';

  for (var _i = 0, _Object$entries = Object.entries(obj.props); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    if (key === 'children') {// do nothing
    } else if (typeof value === 'string') {
      str += " ".concat(key, "={'").concat(value, "'}");
    } else if (_typeof(value) === 'object') {
      str += " ".concat(key, "={").concat(JSON.stringify(value), "}");
    } else {
      str += " ".concat(key, "={").concat(value, "}");
    }
  }

  return str;
}; // Returns the name of the JSX object by checking for a definition file or the type attribute


var nameGetter = function nameGetter(obj) {
  var compName = obj.type;

  if (obj.key) {
    compName = obj.key;
  } else if (obj.definition) {
    compName = obj.definition.name;
  } else if (obj.type.definition) {
    compName = obj.type.definition.name;
  }

  return compName;
}; // obj is the JSX object to be converted
// tabs is the number of whitespace to be added if:
// block is a boolean that dictates whether it should be in block or inline notation when returned


var jsxToString = function jsxToString(obj, tabs) {
  var block = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var str;
  var name = nameGetter(obj);

  if (obj.props.children) {
    str = "<".concat(name).concat(propGetter(obj), ">").concat(block ? "\n".concat(tabs, "  ") : "").concat(childGetter(obj.props.children, tabs, block)).concat(block ? "\n".concat(tabs) : "", "</").concat(name, ">");
  } else {
    str = "<".concat(name).concat(propGetter(obj), " />");
  }

  return str;
};

exports.jsxToString = jsxToString;